
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const bank_augmontsApi = createAsyncThunk("bank_augmonts", async () => {
  const response = await axiosInstance.get("/bank_augmonts");
  return response.data;
});

const bank_augmontsSlice = createSlice({
  name: "bank_augmonts",
  initialState: {
    bank_augmonts: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(bank_augmontsApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(bank_augmontsApi.fulfilled, (state, action) => {
        state.bank_augmonts = action.payload;
        state.loading = false;
      })
      .addCase(bank_augmontsApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default bank_augmontsSlice.reducer;
